//Redirects
function redirectTemplateToHomepage(templateName){

    if (templateName == 404){
        return location.pathname = "/"
    }
}

//Change email
function changeLink(linkHrefUrl, newLink, newName){
    email = document.querySelectorAll(`a[href='${linkHrefUrl}']`);

    return email.forEach(e => {
        e.setAttribute('href', newLink);
        e.innerHTML = newName
    });
}

//Change placeholders
function changePlaceholder(placeholder, newPlaceholder){
    selector = document.querySelectorAll(`input[placeholder='${placeholder}']`);
    
    return selector.forEach(e => {
        e.setAttribute('placeholder', newPlaceholder);
    });
}

function deleteNodes(selectors){
    let nodes = document.querySelectorAll(selectors)
    if(nodes){
        nodes.forEach(el => {
            el.remove()
        })
    }
}

function addCSS(css){
    return document.querySelector('head').insertAdjacentHTML("afterbegin", css)
}